import { $Props } from '@Ravnur-Inc/core/typings/tsx';
import { TextField$Props } from '@Ravnur-Inc/core/ui-kit/text-field/text-field';
import copy from '@Ravnur-Inc/helpers/copy-to-clipboard';
import { Vue, Options, prop } from 'vue-class-component';

import './copy-input.scss';

const CN = 'copy-input';

class Props {
  value = prop({ default: '' });
  readonly = prop({ default: true });
  requiredAsterisk = prop({ default: false });
  placeholder = prop({ default: '' });
}

@Options({
  name: 'copy-input',
  emits: ['update:value'],
})
export default class CopyInput extends Vue.with(Props) {
  declare $props: $Props<Props> & Partial<TextField$Props>;

  protected get local() {
    return this.value;
  }

  protected set local(local) {
    this.$emit('update:value', local);
  }

  render() {
    const attrs = { ...this.$attrs };
    delete attrs.class;

    const cn = {
      [CN]: true,
      [`${CN}--labeled`]: attrs?.label,
    };

    return (
      <div class={cn}>
        <text-field
          class={`${CN}__field`}
          readOnly={this.readonly}
          requiredAsterisk={this.requiredAsterisk}
          vModel={[this.local, 'value']}
          {...attrs}
          placeholder={this.placeholder}
        />
        <action-button
          class={`${CN}__btn`}
          color="primary"
          data-testid="copy-btn"
          icon="copy"
          process={this.copyHandlerGenerator}
        />
      </div>
    );
  }

  private async copyHandlerGenerator() {
    copy(this.value);
    return new Promise((resolve) => setTimeout(resolve, 500));
  }
}
